import { Link } from "react-router-dom";

/**
 * HandStamped — bold horizontal callout reinforcing the "one of one" /
 * hand-stamped scarcity concept. Sits between the marquees and the
 * manifesto / drop sections.
 */
export const HandStamped = () => {
  return (
    <section
      data-testid="hand-stamped"
      className="relative border-b border-[#333] bg-[#050505]"
    >
      <div className="mx-auto grid max-w-[1400px] grid-cols-12 items-center gap-8 px-6 py-10 md:px-10 md:py-20">
        {/* Stamp visual */}
        <div className="col-span-12 flex justify-center md:col-span-4 md:justify-start">
          <div className="animate-stamp -rotate-3 inline-flex flex-col border-2 border-white bg-black px-6 py-5">
            <span className="font-mono-stamp text-[10px] text-[#a0a0a0]">
              RUN TAG / HAND STAMPED
            </span>
            <div className="mt-2 flex items-baseline gap-3 font-mono-stamp text-sm">
              <span>DESIGN #101</span>
              <span className="text-[#555]">|</span>
              <span>ITEM 001/500</span>
            </div>
            <div className="mt-3 border-t border-[#333] pt-2">
              <span className="font-mono-stamp text-[9px] text-[#666]">
                ONE OF A KIND · NEVER REMADE
              </span>
            </div>
          </div>
        </div>

        {/* Copy */}
        <div className="col-span-12 md:col-span-8">
          <span className="font-mono-stamp text-[10px] text-[#a0a0a0]">
            ▸ ONE OF A KIND
          </span>
          <h2 className="font-display mt-4 text-4xl leading-[0.9] md:text-6xl">
            EVERY PIECE
            <br />
            <span className="text-outline">HAND-STAMPED.</span>
          </h2>
          <p className="mt-5 max-w-2xl font-mono-stamp text-xs leading-relaxed text-[#a0a0a0] md:text-sm">
            EACH ITEM CARRIES A UNIQUE RUN TAG — DESIGN NUMBER + ITEM NUMBER —
            STAMPED BY HAND. ONCE THE RUN SELLS OUT, IT IS NEVER REMADE
            EXACTLY THE SAME WAY AGAIN. YOUR PIECE IS LITERALLY ONE OF A KIND.
          </p>
          <div className="mt-6 flex flex-col gap-4 md:flex-row md:items-center">
            <Link
              to="/find-your-fit"
              data-testid="hs-fyf-cta"
              className="btn-brutal"
            >
              CLAIM YOUR NUMBER →
            </Link>
            <span className="font-mono-stamp text-[10px] text-[#666]">
              · NO RESTOCKS · NO COPIES · NO COMPROMISE
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
